import { render, staticRenderFns } from "./saveDetail.vue?vue&type=template&id=b58b0240&scoped=true&"
import script from "./saveDetail.vue?vue&type=script&lang=js&"
export * from "./saveDetail.vue?vue&type=script&lang=js&"
import style0 from "./saveDetail.vue?vue&type=style&index=0&id=b58b0240&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b58b0240",
  null
  
)

export default component.exports